<div class="process-form process-disable">
  <app-dynamic-form [formConfigs]="formConfigs" [formGroup]="processForm" />
  <div class="flex justify-end gap-2!">
    @if (!isReadOnly) {
      <button mat-flat-button [disabled]="isLoading" (click)="handleUpdateProcess()">
        <div class="d-flex align-items-center text-disable">
          <app-loading-icon [loading]="isLoading" />
          {{ 'save' | translate }}
        </div>
      </button>
    }
  </div>
</div>
